var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.list, function (item, i) {
      return _c(
        "div",
        {
          key: i,
          staticClass: "hierarchy-name",
          class: { "is-select": item.selected },
          on: {
            click: function ($event) {
              return _vm.clickSelect(item, i)
            },
          },
        },
        [_vm._v(" " + _vm._s(item.label) + " ")]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }